import axios from 'axios';
import { ApiError } from './error';

// The company admin's "Jobs to do" dialog (components/AdminJobs): guides the
// Product Improvement analysis found in reviews who aren't on TipDirect yet,
// and reviews that need the admin to say which guide it was.
const url = '/api/v1/admin-jobs';

const data = res => res.data.data;

// → { jobs, snoozedUntil, knownGuides }
export const fetchAdminJobs = () => axios.get(url).then(data).catch(ApiError.ofAndThrow);

// "Remind me later" hides the dialog for a day; { clear: true } brings it back.
export const snoozeAdminJobs = ({ clear = false } = {}) =>
  axios
    .post(`${url}/snooze`, clear ? { clear: true } : {})
    .then(data)
    .catch(ApiError.ofAndThrow);

export const inviteFoundGuide = (guideId, { email, tourIds }) =>
  axios
    .post(`${url}/guides/${guideId}/invite`, { email, tourIds })
    .then(data)
    .catch(ApiError.ofAndThrow);

export const linkFoundGuide = (guideId, targetGuideId) =>
  axios
    .post(`${url}/guides/${guideId}/link`, { guideId: targetGuideId })
    .then(data)
    .catch(ApiError.ofAndThrow);

export const dismissFoundGuide = guideId =>
  axios
    .post(`${url}/guides/${guideId}/dismiss`)
    .then(data)
    .catch(ApiError.ofAndThrow);
